const STORAGE_KEY = 'link-park:condominium-filters';

export interface CondominiumFilters {
  showInactiveBlocks: boolean;
  showInactiveSpots: boolean;
}

export function loadCondominiumFilters(): CondominiumFilters {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<CondominiumFilters>;
      return {
        showInactiveBlocks: parsed.showInactiveBlocks === true,
        showInactiveSpots: parsed.showInactiveSpots === true,
      };
    }
  } catch {
    // ignore
  }
  return { showInactiveBlocks: false, showInactiveSpots: false };
}

export function saveCondominiumFilters(filters: CondominiumFilters): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  } catch {
    // ignore
  }
}
